import Head from 'next/head'
import { NextPage } from 'next'
import Container from '@styles/Container'
import ProjectsGrid from '@components/ProjectsGrid'

const WorkPage: NextPage = () => (
  <>
    <Head>
      <title>Work</title>
    </Head>

    <Container className="mb-80 mb-md-200">
      <ProjectsGrid />
    </Container>
  </>
)

export default WorkPage
